import { lazy as lazyLoad } from 'react';

import { route } from './constants';

import type { RouteDefinition } from '../../route';

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.my-growth.title',
        page: lazyLoad(async () => {
            const { MyGrowthPage } = await import('./MyGrowthPage');

            return { default: MyGrowthPage };
        }),
        path: route.patterns.myGrowth,
    },
];
